import { render, staticRenderFns } from "./MenuNav.vue?vue&type=template&id=44625680&"
import script from "./MenuNav.vue?vue&type=script&style=ts&lang=js&"
export * from "./MenuNav.vue?vue&type=script&style=ts&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports